<template>
  <div class="input">
    <label v-if="label" :for="id" class="input__label">{{ label }}</label>

    <textarea
      v-if="textarea"
      :id="id"
      :modelValue="modelValue"
      :name="name"
      :class="fieldClassName"
      @input="onInput"
      @blur="$emit('validate')"
    />

    <input
      v-else
      :id="id"
      :ref="name"
      :name="name"
      type="text"
      :modelValue="modelValue"
      :class="fieldClassName"
      @input="onInput"
      @blur="$emit('validate')"
    />
    <p v-if="error" class="input__error">
      <Icon id="warning" class="input__warning" />{{ errorMessage }}
    </p>
  </div>
</template>

<script>
import Icon from '@/components/global/Icon.vue'

export default {
  name: 'InputText',
  components: { Icon },
  props: {
    id: { type: String, required: true },
    name: { type: String, required: true },
    label: { type: String, default: null },
    modelValue: { type: String, default: null },
    inputClass: { type: [String, Array, Object], default: Array },
    textarea: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    errorMessage: { type: String, default: null },
    hasFocus: { type: Boolean, default: false },
  },
  computed: {
    fieldClassName() {
      return ['input__field', this.inputClass, { '-error': this.error, '-textarea': this.textarea }]
    },
  },
  mounted() {
    if (this.hasFocus)
      this.$nextTick(function () {
        const ref = document.getElementById(this.id)
        ref.focus()
      })
  },
  methods: {
    onInput({ target }) {
      this.$emit('update:modelValue', target.value)
    },
  },
}
</script>
